export default "__VITE_ASSET__BUsB_6HH__"